import { DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import {
  SaveButton,
  TextInput,
  SimpleForm,
  useDataProvider,
  useNotify,
  NumberInput,
  BooleanInput,
  useRefresh,
  useTranslate,
} from 'react-admin';

export default function CreateTask({ onClose }: { onClose: () => void }) {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const translate = useTranslate();
  const [saving, setSaving] = useState(false);
  const refresh = useRefresh();
  const onSubmit = async (values: any) => {
    setSaving(true);
    try {
      const processedValues = {
        ...values,
        name: typeof values.name === 'object' ? values.name : { en: values.name || '' },
        points: Number(values.points) || 0,
        isActive: Boolean(values.isActive),
      };

      await dataProvider.create('activity', { data: processedValues });
      notify(translate('activity.tasks.createdSuccessfully'), { type: 'success' });
      refresh();
      onClose();
    } catch (error) {
      console.error('Create error:', error);
      notify(translate('activity.tasks.failedToCreate'), { type: 'error' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <DialogTitle>{translate('activity.common.createTask')}</DialogTitle>
      <DialogContent>
        <SimpleForm onSubmit={onSubmit} toolbar={<SaveButton alwaysEnable disabled={saving} />}>
          <Stack spacing={2} sx={{ mt: 2 }}>
            <Typography variant="h6">{translate('activity.common.basicInformation')}</Typography>
            <NumberInput source="categoryId" label="CategoryId" fullWidth required defaultValue={1} />

            <Typography variant="h6" sx={{ mt: 2 }}>
              {translate('activity.common.nameMultiLanguage')}
            </Typography>

            <TextInput source="name.en" label={translate('activity.name.en')} fullWidth required />
            <TextInput source="name.zh" label={translate('activity.name.zh')} fullWidth />
            <TextInput source="name.es" label="Name (Spanish)" fullWidth />
            <TextInput source="name.fr" label="Name (French)" fullWidth />

            <Typography variant="h6" sx={{ mt: 2 }}>
              {translate('activity.common.additionalFields')}
            </Typography>

            <TextInput source="description" label={translate('activity.common.description')} fullWidth multiline rows={3} />
            <TextInput source="frequency" label={translate('activity.tasks.frequency')} fullWidth required />
            <TextInput source="taskIdentifier" label={translate('activity.tasks.taskIdentifier')} fullWidth />
            <NumberInput source="points" label={translate('activity.common.points')} fullWidth required defaultValue={1} />
            <TextInput source="maxCompletions" label={translate('activity.tasks.maxCompletions')} fullWidth />
            <TextInput source="resetPeriod" label={translate('activity.tasks.resetPeriod')} fullWidth />
            <TextInput source="conditions" label={translate('activity.common.conditions')} fullWidth />
            <TextInput source="actionTarget" label={translate('activity.tasks.actionTarget')} fullWidth />
            <TextInput source="verificationMethod" label={translate('activity.tasks.verificationMethod')} fullWidth />
            <TextInput source="externalLink" label={translate('activity.tasks.externalLink')} fullWidth />
            <TextInput source="taskIcon" label={translate('activity.tasks.taskIcon')} fullWidth />
            <TextInput source="buttonText" label={translate('activity.tasks.buttonText')} fullWidth />
            <NumberInput source="startDate" label={translate('activity.common.startDate')} fullWidth defaultValue={0} />
            <NumberInput source="endDate" label={translate('activity.common.endDate')} fullWidth defaultValue={0} />
            <NumberInput source="sortOrder" label={translate('activity.common.sortOrder')} fullWidth defaultValue={0} />
          </Stack>
        </SimpleForm>
      </DialogContent>
    </>
  );
}
